import { AiPromptsSettings } from './ui';

export { AiPromptsSettings };
